module.exports = __webpack_public_path__ + "static/media/after.1c07b5ea.png";